import OnlineRenewalStart from '@/components/OnlineRenewalStart.vue'
import OnlineRenewalEmailVerification from '@/components/OnlineRenewalEmailVerification.vue'
import OnlineRenewalQuestions from '@/components/OnlineRenewalQuestions.vue'
import Summary from '@/components/Summary.vue'
import OnlineRenewalTermsAndConditions from '@/components/OnlineRenewalTermsAndConditions.vue'
import OnlineRenewalThankYou from '@/components/OnlineRenewalThankYou.vue'

export default {
    components: {
        OnlineRenewalStart,
        OnlineRenewalEmailVerification,
        OnlineRenewalQuestions,
        Summary,
        OnlineRenewalTermsAndConditions,
        OnlineRenewalThankYou
    },
    data() {
        return {
            eligibleForRenewalResult: true,
            previousPolicies: null,
            existingClaims: null,
            previousClaims: null,
            nswSmallBusinessExemption: null,

            quoteReferenceId: this.$route.params.quote_reference_id,
            companyDetails: null,

            previousPoliciesQuestion: `Has any insurer ever cancelled, declined, refused to renew or imposed special conditions on any of your insurance?`,
            existingClaimsQuestion: `Are you aware of any circumstances that may result in a claim under the insurance policies you are applying for or are you aware of any impending infringement notice or fine under the Education and Care Services National Law or any other relevant Act?`,
            previousClaimsQuestion: `During the last 5 years have any claims been made or threatened against you tha might have been insured under the insurance policies you are applying for?`,
            nswSmallBusinessExemptionQuestion: `Are you a small business as defined in section 259A of the Duties Act 1997 (the Act) for the purposes of the small business exemption in section 259B of the Act?`,
            nswSmallBusinessExemptionAdditionalText: `
            <p>The definition of small business used in the amended Duties Act 1997 is the one used on the Tax Assessment Act 1997.</p>

            <p>* Aggregated turnover is your annual turnover plus the annual turnovers of any business entities that are your affiliates or are connected with you.</p>

            <p>For more information, visit the Revenue NSW website.</p>
            `,
            pricingMatrix: {
                membership: null,
                add_ons: null,
                educator_pl: null,
                educator_pa: null,
                service_pl: null,
                service_pa: null
            }
        }
    },
    computed: {
        fetchSessionDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get.json`,
                params: {
                    target: 'session_by_reference_id',
                    id: this.$route.params.quote_reference_id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchQuoteDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get.json`,
                params: {
                    target: 'quote_by_session_id',
                    session_id: this.$store.state.sessionDetails.id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchPreviousPolicyDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get_policies_by_policy_id.json`,
                params: {
                    id: this.$store.state.sessionDetails.properties.previous_policy_id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchCompanyDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get_company.json`,
                params: {
                    id: this.$store.state.previousPolicyDetails.properties.company_id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }   
        },

        publicLiabilityString() {
            return Number(this.$store.state.quoteDetails.properties.output_pl_base) > 0 ?
            `<span class='icon-check-circle' style='color: #37B68F;'></span>&nbsp;$${this.$store.state.quoteDetails.properties.loi !== null ? this.$store.state.quoteDetails.properties.loi.replace("M", ",000,000") : "20,000,000"}` :
            `<span class='icon-cancel' style='color: #DA6868;'></span>`;
        },
        personalAccidentString() {
            return this.$store.state.sessionDetails.properties.include_personal_accident ? `<span class='icon-check-circle' style='color: #37B68F;'></span>&nbsp;$30,000` : `<span class='icon-cancel' style='color: #DA6868;'></span>`;
        },
        legalAssistanceString() {
            return Number(this.$store.state.quoteDetails.properties.tl_addon_base) > 0 ?
            `<span class='icon-check-circle' style='color: #37B68F;'></span>&nbsp;$${this.dbToString(this.$store.state.quoteDetails.properties.tl_addon_base)} + GST` :
            `<span class='icon-cancel' style='color: #DA6868;'></span>`;
        },
        debtRecoveryString() {
            return Number(this.$store.state.quoteDetails.properties.dr_addon_base) > 0 ?
            `<span class='icon-check-circle' style='color: #37B68F;'></span>&nbsp;$${this.dbToString(this.$store.state.quoteDetails.properties.dr_addon_base)} + GST` :
            `<span class='icon-cancel' style='color: #DA6868;'></span>`;
        },

        riskAddressString() {
            return (this.riskAddress.address2 !== "")
            ? `${this.riskAddress.address1}<br/>${this.riskAddress.address2}<br/>${this.riskAddress.suburb} ${this.riskAddress.state} ${this.riskAddress.postcode}`
            : `${this.riskAddress.address1}<br/>${this.riskAddress.suburb} ${this.riskAddress.state} ${this.riskAddress.postcode}`
        },
        mailingAddressString() {
            return (this.mailingAddress.address_2 !== "")
            ? `${this.mailingAddress.address_1}<br/>${this.mailingAddress.suburb} ${this.mailingAddress.state} ${this.mailingAddress.postcode}`
            : `${this.mailingAddress.address_1}<br/>${this.mailingAddress.suburb} ${this.mailingAddress.state} ${this.mailingAddress.postcode}`
        },

        summaryData() {
            let array = [];
            array.push({ "Package": this.$store.state.sessionDetails.properties.package })
            array.push({ "Start date": this.$options.filters.formatDate(this.$store.state.sessionDetails.properties.policy_start) })
            array.push({ "Expiry Date": this.$options.filters.formatDate(this.$store.state.sessionDetails.properties.policy_expiry) })
            array.push({ "<h1>Cover</h1>": "&nbsp;" })
            array.push({ "Public Liability": this.publicLiabilityString })
            if(this.$store.state.sessionDetails.properties.user_type === 'educator') {
                array.push({ "Personal Accident": this.personalAccidentString })
                array.push({ "Legal Assistance": this.legalAssistanceString })
                array.push({ "Debt Recovery": this.debtRecoveryString })
            }
            array.push({ "&nbsp;": "&nbsp;" })
            return array
        },

        membershipBreakdown() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.output_membership_base) + this.dbToNumber(this.$store.state.quoteDetails.properties.output_membership_base_gst)).toFixed(2);
        },
        publicLiabilityPremiumBreakdown() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_base) + this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_base_gst)).toFixed(2);
        },
        personalAccidentPremiumBreakdown() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_base) + this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_base_gst)).toFixed(2);
        },
        legalServices() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.addons_base) + this.dbToNumber(this.$store.state.quoteDetails.properties.addons_base_gst)).toFixed(2);
        },
        activitiesPremium() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.activities_prorated_premium)).toFixed(2);
        },
        additionalBranchesPremium() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_base) + this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_base_gst)).toFixed(2);
        },
        brokerFee() {
            return (
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_broker) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_broker) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_broker) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.activities_broker_fee)
            ).toFixed(2);
        },
        stampDuty() {
            return (
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_stamp_duty) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_stamp_duty) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_stamp_duty)
            ).toFixed(2);
        },
        totalGSTIncluded() {
            return (
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_membership_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.addons_base_gst) +
                ((Number(this.$store.state.quoteDetails.properties.activities_total_premium / 100) / 1.1) * 0.10) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_broker_gst)
            ).toFixed(2);
        },
        totalPayableBase() {
            return (
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_membership_base) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_membership_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_base) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_base) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.addons_base) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.addons_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_total_fee) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_broker) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_broker) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.activities_total_premium) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_stamp_duty) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_stamp_duty)
            ).toFixed(2);
        },
        interestPremiumFunding() {
            switch(this.$store.state.onlineRenewalPaymentTerms) {
                case 'annual':
                    return 0;

                case 'monthly':
                case 'fortnightly':
                    return (Number(this.totalPayableBase) * 0.10).toFixed(2);
            }
        },
        totalPayable() {
            return (Number(this.totalPayableBase) + Number(this.interestPremiumFunding)).toFixed(2);
        },
        premiumBreakdownData() {
            let array = [];

            if(this.$store.state.sessionDetails.properties.user_type === 'educator') {
                array.push({ "Membership": `$${this.membershipBreakdown}` })
            }

            array.push({ "Public Liability Premium": `$${this.publicLiabilityPremiumBreakdown}` })

            if(this.$store.state.sessionDetails.properties.user_type === 'educator') {
                array.push({ "Personal Accident Premium": `$${this.personalAccidentPremiumBreakdown}` })
            }

            array.push({ "&nbsp;": "&nbsp;" })

            if(this.$store.state.sessionDetails.properties.user_type === 'educator') {
                array.push({ "FDCA Legal Services": `$${this.legalServices}` })
            }

            if(Number(this.activitiesPremium) > 0) {
                array.push({ "Activities Premium": `$${this.activitiesPremium}` });
            }

            if(Number(this.additionalBranchesPremium) > 0) {
                array.push({ "Additional Branches Premium": `$${this.additionalBranchesPremium}` });
            }
            array.push({ "&nbsp;": "&nbsp;" });
            array.push({ "FDCA Broker Fee": `$${this.brokerFee}` });
            array.push({ "Stamp Duty": `$${this.stampDuty}` });
            
            if(this.$store.state.onlineRenewalPaymentTerms !== 'annual') {
                array.push({ "Interest - Premium Funding": `$${this.interestPremiumFunding}` });
            }
            
            array.push({ "&nbsp;": "&nbsp;" });
            array.push({ "Total GST Included": `$${this.totalGSTIncluded}` });
            array.push({ "TOTAL PAYABLE": `$${this.totalPayable}` });

            return array;
        },
        
        policyHolderInformationData() {
            let array = []

            if(this.$store.state.sessionDetails.properties.user_type === 'service') {
                array.push({ "FDCA Member Number": this.$store.state.previousPolicyDetails.properties.member_no });
            }

            array.push({ "Insured Name": this.$store.state.sessionDetails.properties.insured_name });
            if(this.dualEducator !== "") {
                array.push({ "Dual Educator": this.dualEducator });
            }
            array.push({ "Risk Address": this.riskAddressString });
            array.push({ "Mailing Address": this.mailingAddressString });
            
            if(this.$store.state.sessionDetails.properties.user_type === 'educator') {
                array.push({ "Registered Service": this.registeredService.service_name })
            } else {
                array.push({"Number of Educators": this.$store.state.sessionDetails.properties.number_of_educators})
            }

            array.push({ "&nbsp;": "&nbsp;" })
            
            return array
        },
        dualEducator() {
            let parsed_educator = JSON.parse(this.$store.state.sessionDetails.properties.dual_educators);
            let dualEduatorObject = Array.isArray(parsed_educator) ? parsed_educator[0] : parsed_educator;
            return Object.keys(dualEduatorObject).length > 0 ? `${dualEduatorObject.first_name} ${dualEduatorObject.last_name}` : "";
        },
        riskAddress() {
            return JSON.parse(this.$store.state.sessionDetails.properties.insured_address);
        },
        mailingAddress() {
            return (this.$store.state.companyDetails.fdca_address.length > 0) ?
            this.$store.state.companyDetails.fdca_address[0].properties :
            [];
        },
        registeredService() {
            return JSON.parse(this.$store.state.companyDetails.fdca_company[0].properties.service);
        },
        eligibleForRenewal() {
            let policyExpiry = this.$store.state.previousPolicyDetails.properties.policy_expiry,
            eligibleRenewalDate = moment(policyExpiry).subtract('days', 45),
            isEligible = moment().isAfter(eligibleRenewalDate);

            // Declarations must be answered NO
            // Renewed Policy must have DO NOT RENEW set to false
            // Renewed Policy must be ACTIVE
            // Renewed Policy expiry must be at least 45 days from TODAY
            if (
                (this.previousPolicies || this.existingClaims || this.previousClaims) ||

                this.$store.state.previousPolicyDetails.properties.do_not_renew ||
                this.$store.state.previousPolicyDetails.properties.policy_status !== 'Active' ||
                isEligible === false
            ) {
                return false;
            } else {
                return true;
            }
        },









        /* Computed Dollar Values */
        /* Computed Dollar Values */
        /* Computed Dollar Values */
        outputPL() {
            return this.$store.state.sessionDetails.properties.user_type === "educator" ? "educator_pl" : "service_pl";
        },
        outputPA() {
            return this.$store.state.sessionDetails.properties.user_type === "educator" ? "educator_pa" : "service_pa";
        },
        computedMembershipFee() {
            return this.pricingMatrix.membership ?
            (Number(this.pricingMatrix.membership.properties.output_base) + Number(this.pricingMatrix.membership.properties.output_base_gst)).toFixed(2) :
            Number(0).toFixed(2);
        },
        computedPublicLiabilityPremium() {
            return this.pricingMatrix[this.outputPL] ?
            (Number(this.pricingMatrix[this.outputPL].properties.output_pl_base) + Number(this.pricingMatrix[this.outputPL].properties.output_pl_base_gst)).toFixed(2) :
            Number(0).toFixed(2);
        },
        computedPersonalAccidentPremium() {
            return this.pricingMatrix[this.outputPA] ?
            (Number(this.pricingMatrix[this.outputPA].properties.output_pa_base) + Number(this.pricingMatrix[this.outputPA].properties.output_pa_base_gst)).toFixed(2) :
            Number(0).toFixed(2);
        },
        computedAddOnsPremium() {
            return this.pricingMatrix.add_ons ?
            (Number(this.pricingMatrix.add_ons.properties.addons_base) + Number(this.pricingMatrix.add_ons.properties.addons_base_gst)).toFixed(2) :
            Number(0).toFixed(2);
        },
        computedActivitiesProRatedPremium() {
            let activities = JSON.parse(this.$store.state.sessionDetails.properties.activities),
            amount = 0;
            
            if(activities.length > 0) {

                activities.forEach(data => {
                    amount += Number(data.activities_prorated_premium);
                });

                return Number(amount).toFixed(2);
                
            } else {
                return Number(0).toFixed(2);
            }
        },
        computedActivitiesBrokerFee() {
            let activities = JSON.parse(this.$store.state.sessionDetails.properties.activities),
            amount = 0;
            
            if(activities.length > 0) {

                activities.forEach(data => {
                    amount += Number(data.activity_broker_fee);
                });

                return Number(amount).toFixed(2);
                
            } else {
                return Number(0).toFixed(2);
            }
        },
        computedActivitiesBrokerFeeGST() {
            let activities = JSON.parse(this.$store.state.sessionDetails.properties.activities),
            amount = 0;
            
            if(activities.length > 0) {

                activities.forEach(data => {
                    amount += Number((data.activity_broker_fee / 1.1) * 0.10);
                });

                return Number(amount).toFixed(2);
                
            } else {
                return Number(0).toFixed(2);
            }
        },
        computedActivitiesTotalPremium() {
            let activities = JSON.parse(this.$store.state.sessionDetails.properties.activities),
            amount = 0;
            
            if(activities.length > 0) {

                activities.forEach(data => {
                    amount += Number(data.activity_total_premium);
                });

                return Number(amount).toFixed(2);
                
            } else {
                return Number(0).toFixed(2);
            }
        },
        computedAdditionalBranchesPremium() {
            if(this.pricingMatrix.service_pl) {
                return (Number(this.pricingMatrix.service_pl.properties.additional_branches_total_pl_base) + Number(this.pricingMatrix.service_pl.properties.additional_branches_total_pl_base_gst)).toFixed(2);
            } else {
                return Number(0).toFixed(2);
            }
        },
        computedAdditionalBranchesBase() {
            if(this.pricingMatrix.service_pl) {
              return Number(this.pricingMatrix.service_pl.properties.additional_branches_total_pl_base).toFixed(2);
            } else {
              return Number(0).toFixed(2);
            }
        },
        computedAdditionalBranchesBaseGST() {
            if(this.pricingMatrix.service_pl) {
              return Number(this.pricingMatrix.service_pl.properties.additional_branches_total_pl_base_gst).toFixed(2);
            } else {
              return Number(0).toFixed(2);
            }
        },
        computedAdditionalBranchesTotalGST() {
            if(this.pricingMatrix.service_pl) {
              return Number(this.pricingMatrix.service_pl.properties.additional_branches_total_gst).toFixed(2);
            } else {
              return Number(0).toFixed(2);
            }
        },
        computedAdditionalBranchesBrokerFee() {
            if(this.pricingMatrix.service_pl) {
              return Number(this.pricingMatrix.service_pl.properties.additional_branches_total_pl_broker).toFixed(2);
            } else {
              return Number(0).toFixed(2);
            }
        },
        computedAdditionalBranchesBrokerFeeGST() {
            if(this.pricingMatrix.service_pl) {
              return Number(this.pricingMatrix.service_pl.properties.additional_branches_total_pl_broker_gst).toFixed(2);
            } else {
              return Number(0).toFixed(2);
            }
        },
        computedAdditionalBranchesStampDuty() {
            if(this.pricingMatrix.service_pl) {
              return Number(this.pricingMatrix.service_pl.properties.additional_branches_total_stamp_duty).toFixed(2);
            } else {
              return Number(0).toFixed(2);
            }
        },
        computedAdditionalBranchesTotal() {
            if(this.pricingMatrix.service_pl) {
              return Number(this.pricingMatrix.service_pl.properties.additional_branches_total).toFixed(2);
            } else {
              return Number(0).toFixed(2);
            }
        },




        computedBrokerFee() {
            let addend_1 = this.pricingMatrix.membership ? (Number(this.pricingMatrix.membership.properties.output_broker) + Number(this.pricingMatrix.membership.properties.output_broker_gst)) : 0,
            addend_2 = this.pricingMatrix[this.outputPA] ? (Number(this.pricingMatrix[this.outputPA].properties.output_pa_broker) + Number(this.pricingMatrix[this.outputPA].properties.output_pa_broker_gst)) : 0,
            addend_3 = this.pricingMatrix[this.outputPL] ? (Number(this.pricingMatrix[this.outputPL].properties.output_pl_broker) + Number(this.pricingMatrix[this.outputPL].properties.output_pl_broker_gst)) : 0,
            addend_4 = Number(this.computedAdditionalBranchesBrokerFee),
            addend_5 = Number(this.computedAdditionalBranchesBrokerFeeGST),
            addend_6 = Number(this.computedActivitiesBrokerFee),
            sum = addend_1 + addend_2 + addend_3 + addend_4 + addend_5 + addend_6;

            return Number(sum).toFixed(2);
        },
        computedBrokerFeeGST() {
            let addend_1 = this.pricingMatrix.membership ? Number(this.pricingMatrix.membership.properties.output_broker_gst) : 0,
            addend_2 = this.pricingMatrix[this.outputPA] ? Number(this.pricingMatrix[this.outputPA].properties.output_pa_broker_gst) : 0,
            addend_3 = this.pricingMatrix[this.outputPL] ? Number(this.pricingMatrix[this.outputPL].properties.output_pl_broker_gst) : 0,
            sum = addend_1 + addend_2 + addend_3;

            return Number(sum).toFixed(2);
        },
        computedTotalGST() {
            let addend_1 = this.pricingMatrix.membership ? Number(this.pricingMatrix.membership.properties.output_base_gst) : 0,
            addend_2 = this.pricingMatrix.membership ? Number(this.pricingMatrix.membership.properties.output_broker_gst) : 0,
            addend_3 = this.pricingMatrix[this.outputPL] ? Number(this.pricingMatrix[this.outputPL].properties.output_pl_base_gst) : 0,
            addend_4 = this.pricingMatrix[this.outputPL] ? Number(this.pricingMatrix[this.outputPL].properties.output_pl_broker_gst) : 0,
            addend_5 = this.pricingMatrix[this.outputPA] ? Number(this.pricingMatrix[this.outputPA].properties.output_pa_base_gst) : 0,
            addend_6 = this.pricingMatrix[this.outputPA] ? Number(this.pricingMatrix[this.outputPA].properties.output_pa_broker_gst) : 0,
            addend_7 = this.pricingMatrix.add_ons ? Number(this.pricingMatrix.add_ons.properties.addons_base_gst) : 0,
            addend_8 = ((Number(this.computedActivitiesTotalPremium) / 1.1) * 0.10),
            addend_9 = this.computedAdditionalBranchesTotalGST,
            sum = addend_1 + addend_2 + addend_3 + addend_4 + addend_5 + addend_6 + addend_7 + addend_8 + addend_9;

            return Number(sum).toFixed(2);
        },
        computedStampDuty() {
            let addend_1 = this.pricingMatrix.membership ? Number(this.pricingMatrix.membership.properties.output_stamp_duty) : 0,
            addend_2 = this.pricingMatrix[this.outputPA] ? Number(this.pricingMatrix[this.outputPA].properties.output_pa_stamp_duty) : 0,
            addend_3 = this.pricingMatrix[this.outputPL] ? Number(this.pricingMatrix[this.outputPL].properties.output_pl_stamp_duty) : 0,
            addend_4 = Number(this.computedAdditionalBranchesStampDuty),
            sum = addend_1 + addend_2 + addend_3 + addend_4;

            return Number(sum).toFixed(2);
        },
        computedPremiumBreakdownSubTotal() {
            return (
                Number(this.computedMembershipFee) +
                Number(this.computedPublicLiabilityPremium) +
                Number(this.computedPersonalAccidentPremium) +
                Number(this.computedAddOnsPremium) +
                Number(this.computedBrokerFee) +
                Number(this.computedActivitiesProRatedPremium) +
                Number(this.computedActivitiesBrokerFee) +
                Number(this.computedStampDuty) +
                Number(this.computedAdditionalBranchesPremium) +
                Number(this.$store.state.sessionDetails.properties.npc_discount_amount) -
                Number(this.$store.state.sessionDetails.properties.flat_discount_value)
            ).toFixed(2);
        }
        /* /Computed Dollar Values */
        /* /Computed Dollar Values */
        /* /Computed Dollar Values */
    },
    methods: {
        async fetchSessionDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchSessionDetailsPayload);
            if(response.data.items.total_entries > 0) {
                
                this.$store.commit('mutate', {
                    property: 'sessionDetails',
                    value: response.data.items.results[0]
                })
                this.$store.commit('mutate', {
                    property: 'onlineRenewalPaymentTerms',
                    value: this.$store.state.sessionDetails.properties.payment_terms
                });

                // If logged in
                // check email of session fetched with quote reference id
                // should match session
                if(
                    !this.$store.state.onlineRenewalEmail ||
                    this.$store.state.onlineRenewalEmail === this.$store.state.sessionDetails.properties.email
                ) {
                    this.fetchQuoteDetails();
                } else {
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: 'Quote reference id does not match with logged session!'
                    })
                    this.$store.commit('mutate', {
                        property: 'onlineRenewalEmail',
                        value: null
                    })
                }
            }
        },
        async fetchQuoteDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchQuoteDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'quoteDetails',
                    value: response.data.items.results[0]
                })
                this.fetchPreviousPolicyDetails();
            }
        },
        async fetchPreviousPolicyDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchPreviousPolicyDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'previousPolicyDetails',
                    value: response.data.items.results[0]
                })
                this.paymentTerms = this.$store.state.previousPolicyDetails.properties.payment_terms;
                this.fetchCompanyDetails();
            }
        },
        async fetchCompanyDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchCompanyDetailsPayload)
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'companyDetails',
                    value: response.data.items.results[0]
                })
            }
        },
        previousPoliciesDeclaration($value) {
            this.previousPolicies = $value;
            this.$store.commit('mutate', {
                property: 'onlineRenewalStep',
                value: this.$store.state.onlineRenewalStep + 1
            })
        },
        existingClaimsDeclaration($value) {
            this.existingClaims = $value;
            this.$store.commit('mutate', {
                property: 'onlineRenewalStep',
                value: this.$store.state.onlineRenewalStep + 1
            })
        },
        previousClaimsDeclaration($value) {
            this.previousClaims = $value;
            if(this.riskAddress.state === 'NSW') {
                this.$store.commit('mutate', {
                    property: 'onlineRenewalStep',
                    value: this.$store.state.onlineRenewalStep + 1
                })
            } else {
                this.$store.commit('mutate', {
                    property: 'onlineRenewalStep',
                    value: this.$store.state.onlineRenewalStep + 2
                })
            }
        },
        async nswSmallBusinessExemptionDeclaration($value) {
            let payload = {
                method: 'put',
                url: `${this.baseURL}/api/cfa/update_session_small_business_disclaimer.json`,
                data: {
                    id: this.$store.state.sessionDetails.id,
                    small_business_disclaimer: $value.toString()
                }
            },
            response = await this.$store.dispatch('fetchData', payload);            
            this.generateAllPricingMatrix();
            this.nswSmallBusinessExemption = $value;
        },
        generateAllPricingMatrix() {
            let requests = [],
            addresses = JSON.parse(this.$store.state.sessionDetails.properties.addresses),
            additionalBranches = JSON.parse(this.$store.state.sessionDetails.properties.additional_branches),
            addressCount = this.$store.state.sessionDetails.properties.user_type === "educator" ? addresses.length : additionalBranches.length + 1;
            
            this.clearPricingMatrix();
            
            requests.push(this.generatePricingMatrix("add_ons"));

            if(
                this.$store.state.sessionDetails.properties.user_type !== "service" &&
                !this.isInvalid(this.$store.state.sessionDetails.properties.package_code) &&
                this.$store.state.sessionDetails.properties.include_membership === true
            ) {
                requests.push(this.generatePricingMatrix("membership"));
            }

            if(addressCount > 0 && !this.isInvalid(this.$store.state.sessionDetails.properties.registered_for_gst)) {
                if(this.$store.state.sessionDetails.properties.user_type === "educator") {
                    requests.push(this.generatePricingMatrix("educator_pl"));
                } else {
                    requests.push(this.generatePricingMatrix("service_pl"));
                }
            }

            if(
                addressCount > 0 &&
                this.$store.state.sessionDetails.properties.user_type === "educator" &&
                this.$store.state.sessionDetails.properties.include_personal_accident
            ) {
                requests.push(this.generatePricingMatrix("educator_pa"));
            }
            
            Promise.all(requests)
            .then(() => {
                this.updateQuote();
            });
        },
        async updateQuote() {
            let payload = {
                method: 'put',
                url: `${this.baseURL}/main/update_quotes.json`,
                data: this.returnUpdateQuotePayload()
            },
            response = await this.$store.dispatch('fetchData', payload);
            this.$store.commit('mutate', {
                property: 'onlineRenewalStep',
                value: this.$store.state.onlineRenewalStep + 1
            })
        },
        returnUpdateQuotePayload() {

            return {
                "token": document.getElementsByName('cmb-api-token')[0].content,
                "token_name": "cmb-auth",
                "user_id": this.$store.state.sessionDetails.user_id,
                "session_id": this.$store.state.sessionDetails.id,
                "quote_id": this.$store.state.quoteDetails.id,
                "user_type": this.$store.state.sessionDetails.properties.user_type,
                "activities_count": JSON.parse(this.$store.state.sessionDetails.properties.activities).length.toString(),
                "output_membership_base": this.pricingMatrix.membership ? this.pricingMatrix.membership.properties.output_base.toString() : null,
                "output_membership_base_gst": this.pricingMatrix.membership ? this.pricingMatrix.membership.properties.output_base_gst.toString() : null,
                "output_pl_base": this.pricingMatrix[this.outputPL] ? this.pricingMatrix[this.outputPL].properties.output_pl_base.toString() : null,
                "output_pl_base_gst": this.pricingMatrix[this.outputPL] ? this.pricingMatrix[this.outputPL].properties.output_pl_base_gst.toString() : null,
                "output_pl_stamp_duty": this.pricingMatrix[this.outputPL] ? this.pricingMatrix[this.outputPL].properties.output_pl_stamp_duty.toString() : null,
                "output_pl_broker": this.pricingMatrix[this.outputPL] ? this.pricingMatrix[this.outputPL].properties.output_pl_broker.toString() : null,
                "output_pl_broker_gst": this.pricingMatrix[this.outputPL] ? this.pricingMatrix[this.outputPL].properties.output_pl_broker_gst.toString() : null,
                "output_pa_base": this.pricingMatrix[this.outputPA] ? this.pricingMatrix[this.outputPA].properties.output_pa_base.toString() : null,
                "output_pa_base_gst": this.pricingMatrix[this.outputPA] ? this.pricingMatrix[this.outputPA].properties.output_pa_base_gst.toString() : null,
                "output_pa_stamp_duty": this.pricingMatrix[this.outputPA] ? this.pricingMatrix[this.outputPA].properties.output_pa_stamp_duty.toString() : null,
                "output_pa_broker": this.pricingMatrix[this.outputPA] ? this.pricingMatrix[this.outputPA].properties.output_pa_broker.toString() : null,
                "output_pa_broker_gst": this.pricingMatrix[this.outputPA] ? this.pricingMatrix[this.outputPA].properties.output_pa_broker_gst.toString() : null,
                "admin_fee": "0",
                "admin_fee_gst": "0",
                "tl_addon_base": this.pricingMatrix.add_ons ? this.pricingMatrix.add_ons.properties.tl_addon_base.toString() : null,
                "tl_addon_base_gst": this.pricingMatrix.add_ons ? this.pricingMatrix.add_ons.properties.tl_addon_base_gst.toString() : null,
                "dr_addon_base": this.pricingMatrix.add_ons ? this.pricingMatrix.add_ons.properties.dr_addon_base.toString() : null,
                "dr_addon_base_gst": this.pricingMatrix.add_ons ? this.pricingMatrix.add_ons.properties.dr_addon_base_gst.toString() : null,
                "policy_premium_total": this.computedPremiumBreakdownSubTotal.toString(),
                "is_deleted": "false",
                "addons_base": this.pricingMatrix.add_ons ? this.pricingMatrix.add_ons.properties.addons_base.toString() : null,
                "addons_base_gst": this.pricingMatrix.add_ons ? this.pricingMatrix.add_ons.properties.addons_base_gst.toString() : null,
                "addons_total": this.pricingMatrix.add_ons ? this.pricingMatrix.add_ons.properties.addons_total.toString() : null,
                "activities_prorated_premium": (Number(this.computedActivitiesProRatedPremium).toFixed(2)).toString(),
                "activities_broker_fee": (Number(this.computedActivitiesBrokerFee).toFixed(2)).toString(),
                "activities_total_premium": (Number(this.computedActivitiesProRatedPremium) + Number(this.computedActivitiesBrokerFee)).toFixed(2).toString(),
                "activities_broker_fee_gst": this.computedActivitiesBrokerFeeGST,
                "loi": this.pricingMatrix[this.outputPL] ? this.pricingMatrix[this.outputPL].properties.loi : null,
                "additional_branches_base": this.computedAdditionalBranchesBase,
                "additional_branches_base_gst": this.computedAdditionalBranchesBaseGST,
                "additional_branches_stamp_duty": this.computedAdditionalBranchesStampDuty,
                "additional_branches_broker": this.computedAdditionalBranchesBrokerFee,
                "additional_branches_broker_gst": this.computedAdditionalBranchesBrokerFeeGST,
                "additional_branches_total_fee": this.computedAdditionalBranchesTotal,

                "npc_discount_code": this.$store.state.sessionDetails.properties.npc_discount_code === null ? "" : this.$store.state.sessionDetails.properties.npc_discount_code,
                "npc_discount_amount": this.$store.state.sessionDetails.properties.npc_discount_amount === null ? "" : this.$store.state.sessionDetails.properties.npc_discount_amount,
                "npc_discount_code_yn": this.$store.state.sessionDetails.properties.npc_discount_code_yn === null ? "" : this.$store.state.sessionDetails.properties.npc_discount_code_yn,

                "flat_discount_type": this.$store.state.sessionDetails.properties.flat_discount_type === null ? "" : this.$store.state.sessionDetails.properties.flat_discount_type,
                "flat_discount_value": this.$store.state.sessionDetails.properties.flat_discount_value === null ? "" : this.$store.state.sessionDetails.properties.flat_discount_value,
                "flat_discount_code": this.$store.state.sessionDetails.properties.flat_discount_code === null ? "" : this.$store.state.sessionDetails.properties.flat_discount_code,
                "flat_discount_off": this.$store.state.sessionDetails.properties.flat_discount_off === null ? "" : this.$store.state.sessionDetails.properties.flat_discount_off,
            }
            
        },
        generatePricingMatrix($matrix) {
            let additionalBranchesStates = [],
            additionalBranches = JSON.parse(this.$store.state.sessionDetails.properties.additional_branches),
            insuredAddress = JSON.parse(this.$store.state.sessionDetails.properties.insured_address),
            policyTerm;

            switch(this.$store.state.sessionDetails.properties.policy_term) {
                case "12 months":
                case "Custom":
                    policyTerm = 12;
                    break;
                case "6 months":
                    policyTerm = 6;
                    break;
                case "3 months":
                    policyTerm = 3;
                    break;
            }

            if($matrix === "service_pl" && additionalBranches.length > 0) {
                additionalBranches.forEach(data => {
                    additionalBranchesStates.push(data.address.state);
                })
            }

            let data = {
                state: insuredAddress.state,
                user_type: this.$store.state.sessionDetails.properties.user_type,
                add_ons_cover: this.returnAdditionalCoverCode(),
                package_code: this.$store.state.sessionDetails.properties.package_code,
                number_of_educators: this.$store.state.sessionDetails.properties.number_of_educators === null ? "" : this.$store.state.sessionDetails.properties.number_of_educators,
                registered_for_gst: this.$store.state.sessionDetails.properties.registered_for_gst,
                small_business_in_nsw: this.$store.state.sessionDetails.properties.small_business_disclaimer === null ? false : this.$store.state.sessionDetails.properties.small_business_disclaimer,
                additional_branches_count: this.$store.state.sessionDetails.properties.user_type === "educator" ? 0 : additionalBranches.length,
                has_pa: this.$store.state.sessionDetails.properties.include_personal_accident,
                has_dual_educator: this.$store.state.sessionDetails.properties.policy_type.toLowerCase() === "dual educators" ? true : false,
                policy_term: policyTerm,
                transaction_type: this.$store.state.sessionDetails.properties.transaction_type,
                additional_branches_states: additionalBranchesStates
            }
            
            let payload = {
                method: 'get',
                url: `${this.baseURL}/main/get_lookup_key.json`,
                params: {
                    "token": document.getElementsByName('cmb-api-token')[0].content,
                    "token_name": "cmb-auth",
                    "matrix": $matrix,
                    "payload": data,
                    "target": "lookup_key_generate"
                }
            };

            return this.$store.dispatch('fetchData', payload).then(response => {
                if(response.data.items && response.data.items.results.length > 0) {
                    this.pricingMatrix[$matrix] = response.data.items.results[0];
                }
            })
        },
        clearPricingMatrix() {
            this.pricingMatrix.membership = null;
            this.pricingMatrix.add_ons = null;
            this.pricingMatrix.educator_pl = null;
            this.pricingMatrix.educator_pa = null;
            this.pricingMatrix.service_pl = null;
            this.pricingMatrix.service_pa = null;
        },
        returnAdditionalCoverCode() {
            let additionalCoverArray = !this.isInvalid(this.$store.state.sessionDetails.properties.additional_cover) ? this.$store.state.sessionDetails.properties.additional_cover.split(",") : [],
            additionalCoverCode = null;

            if(additionalCoverArray.length === 2) {
                additionalCoverCode = "BT";
            } else if(additionalCoverArray.length === 0) {
                additionalCoverCode = "None";
            } else if(additionalCoverArray.length === 1) {
                if(additionalCoverArray[0] === "telephone legal assistance") {
                    additionalCoverCode = "TL"; 
                } else if(additionalCoverArray[0] === "debt recovery") {
                    additionalCoverCode = "DR"; 
                }
            }

            return additionalCoverCode;
        },









        
        decrementStep() {
            if(this.$store.state.onlineRenewalStep > 1) {
                this.$store.commit('mutate', {
                    property: 'onlineRenewalStep',
                    value: this.$store.state.onlineRenewalStep - 1
                })
            }
        },
        async updatePaymentTerms($value) {
            let payload = {
                method: 'put',
                url: `${this.baseURL}/api/cfa/update_session_payment_terms.json`,
                data: {
                    id: this.$store.state.sessionDetails.id,
                    payment_terms: $value
                }
            },
            response = await this.$store.dispatch('fetchData', payload);
            
            this.$store.commit('mutate', {
                property: 'onlineRenewalPaymentTerms',
                value: $value
            });
        },
        purchaseRenewal() {
            this.$store.commit('mutate', {
                property: 'onlineRenewalStep',
                value: this.$store.state.onlineRenewalStep + 1
            })
        },
        dbToString($value) {
            return ($value / 100).toFixed(2).toString();
        },
        dbToNumber($value) {
            return Number($value / 100);
        },
        async fetchStripeKey() {
            let payload = {
                method: 'get',
                url: `api/cfa/get_stripe_settings.json`
            },
            response = await this.$store.dispatch('fetchData', payload),
            settings = JSON.parse(response.data.items.results.filter(data => data.name === "insites_stripe_settings")[0].value),
            insites_stripe_pk_test_key = response.data.items.results.filter(data => data.name === "insites_stripe_pk_test_key")[0].value,
            insites_stripe_pk_live_key = response.data.items.results.filter(data => data.name === "insites_stripe_pk_live_key")[0].value,
            key = settings.livemode ? insites_stripe_pk_live_key : insites_stripe_pk_test_key;
            
            this.$store.commit('mutate', {
                property: 'stripePublishableKey',
                value: key
            })
        },
        async setQuoteReferenceIdFromUrlParam() {
            let payload = {
                method: 'get',
                url: `${this.baseURL}/api/cfa/get_session_by_reference_id.json`,
                params: {
                    id: this.$route.params.quote_reference_id
                }
            },
            response = await this.$store.dispatch('fetchData', payload);
            if(response.data.items.results.length === 0) {
              Swal.fire({
                type: 'error',
                title: 'Oops...',
                text: 'This is not a valid reference id!'
              })
            } else {
              this.$store.commit('mutate', {
                property: 'onlineRenewalQuoteReferenceId',
                value: this.$route.params.quote_reference_id
              })
              this.fetchSessionDetails();
            }
        }
    },
    created(){
        window.location.assign('/member/login');  
    },
    mounted() {
    }
}